import { createContext } from 'react';

export interface VideoProps {
  isVideo: boolean;
  srcId: string;
  videoSrc: string;
  setIsVideo: React.Dispatch<React.SetStateAction<boolean>>;
  setSrcId: React.Dispatch<React.SetStateAction<string>>;
  setVideoSrc: React.Dispatch<React.SetStateAction<string>>;
};

const contextDefault: VideoProps = {
  isVideo: false,
  srcId: '',
  videoSrc: '',
  setIsVideo: () => {},
  setSrcId: () => {},
  setVideoSrc: () => {},
};

const VideoContext = createContext<VideoProps>(contextDefault);

export default VideoContext;